var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCheneliere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.6 37.8",
    style: {
      enableBackground: "new 0 0 87.6 37.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00447C;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 87.6,
    height: 37.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.1,
    y: 18.9,
    className: "st1",
    width: 85.4,
    height: 17.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.1,5.4C11.4,5.1,10.5,5,9.8,5C7.1,5,5.6,6.9,5.6,9.4c0,2.6,1.5,4.4,4.2,4.4c0.7,0,1.7-0.1,2.3-0.4l0.1,0.9 c-0.6,0.3-1.7,0.4-2.4,0.4c-3.2,0-5.2-2.1-5.2-5.3c0-3.1,2-5.3,5.2-5.3c0.6,0,1.8,0.1,2.4,0.4L12.1,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.1,4.3h1v4.5h5.2V4.3h1v10.3h-1V9.7h-5.2v4.8h-1V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.1,4.3h5v0.9h-4v3.7h3.8v0.9h-3.8v4h4.2v0.9h-5.2V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.7,4.3H34l5.2,9h0v-9h1v10.3h-1.4l-5.1-8.8h0v8.8h-1V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.1,4.3h5v0.9h-4v3.7h3.8v0.9h-3.8v4h4.2v0.9h-5.2V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.7,4.3h1v9.4h4.1v0.9h-5.1V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.7,4.3h1v10.3h-1V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.5,4.3h5v0.9h-4v3.7h3.8v0.9h-3.8v4h4.2v0.9h-5.2V4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.2,4.3h2.6c1.8,0,3,0.8,3,2.7c0,1.3-1,2.2-2.3,2.4v0c0.8,0.1,1,0.5,1.3,1.2l1.7,4h-1.1l-1.5-3.5 c-0.6-1.3-1-1.4-2-1.4h-0.8v4.8h-1V4.3z M70.3,8.8h1.1c1.2,0,2.6-0.5,2.6-1.9c0-1.7-1.2-1.8-2.6-1.8h-1V8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.8,4.3h5v0.9h-4v3.7h3.8v0.9h-3.8v4H83v0.9h-5.2V4.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "66.5,3.2 61.5,3.2 61.5,2.3 66.1,2.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,23.2h5v0.9h-4v3.7h3.8v0.9H6.1v4h4.2v0.9H5V23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,23.2h2.5c3.7,0,5.1,2.1,5.1,5.1c0,3.7-2.5,5.1-5.9,5.1h-1.8V23.2z M13.7,32.6h0.8 c2.9,0,4.8-1.2,4.8-4.3c0-3.1-1.9-4.2-4.2-4.2h-1.5V32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,29.9c0,3-2.2,3.8-3.7,3.8c-1.5,0-3.7-0.7-3.7-3.8v-6.7h1v6.7c0,1.7,0.9,2.9,2.7,2.9 c1.8,0,2.7-1.2,2.7-2.9v-6.7h1V29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,24.4c-0.6-0.3-1.6-0.4-2.3-0.4c-2.7,0-4.2,1.9-4.2,4.4c0,2.6,1.5,4.4,4.2,4.4c0.7,0,1.7-0.1,2.3-0.4 l0.1,0.9c-0.6,0.3-1.7,0.4-2.4,0.4c-3.2,0-5.2-2.1-5.2-5.3c0-3.1,2-5.3,5.2-5.3c0.6,0,1.8,0.1,2.4,0.4L40.1,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.3,23.2h1.1l4.1,10.3h-1.1l-1.1-2.7h-5.2l-1.1,2.7h-1L46.3,23.2z M46.8,24.2l-2.2,5.7h4.5L46.8,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.3,24.1h-3v-0.9h7.1v0.9h-3v9.4h-1V24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.9,23.2h1v10.3h-1V23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.7,23c3.1,0,4.5,2.5,4.5,5.3c0,3.1-1.6,5.3-4.5,5.3c-3,0-4.5-2.2-4.5-5.3C64.2,25.6,65.6,23,68.7,23z  M65.2,28.3c0,2.2,1.1,4.4,3.5,4.4c2.4,0,3.5-2.3,3.5-4.4s-1.1-4.4-3.5-4.4C66.3,23.9,65.2,26.2,65.2,28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.5,23.2h1.3l5.2,9h0v-9h1v10.3h-1.4l-5.1-8.8h0v8.8h-1V23.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10.1,21.4 5,21.4 5,22.3 9.6,22.3  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCheneliere);
export default __webpack_public_path__ + "static/media/Logo-Cheneliere.9171eed6f313d21f4718a264cb76ee34.svg";
export { ForwardRef as ReactComponent };